<template>
  <div class="c-typography-configurator flex flex-col gap-6">
    <CTypographyConfiguratorItem
      v-for="item of sortedItems"
      :key="item.id"
      :font-options="fontOptions"
      :item="item"
      :palette="palette"
      @update:item="(newItem: CanvasTypographyPreset) => updateConfig(item.id, newItem)"
    />
  </div>
</template>

<script setup lang="ts">
import { sortBy } from 'lodash-es'
import type { SelectOption } from 'naive-ui'
import { computed } from 'vue'

import CTypographyConfiguratorItem from '@lib/components/CTypographyConfigurator/CTypographyConfiguratorItem.vue'
import { type CanvasTypographyPreset } from '@lib/types/canvasTheme'
import { textStylePresets } from '@theme/theme.utils'

const props = defineProps<{
  configuration: Record<string, CanvasTypographyPreset>
  fontOptions: SelectOption[]
  palette?: string[]
}>()

const emit = defineEmits<{ 'update:configuration': [c: Record<string, CanvasTypographyPreset>] }>()

const sortedItems = computed(() =>
  sortBy(Object.values(props.configuration), (item) => textStylePresets.findIndex((i) => i.id === item.id)),
)

function updateConfig(id: string, newConfig: CanvasTypographyPreset) {
  emit('update:configuration', { ...props.configuration, [id]: newConfig })
}
</script>
